module.exports = __webpack_public_path__ + "img/b0cb00a.png";